module.exports = __webpack_public_path__ + "img/szw3.55aa3cdc.jpg";